export default "__VITE_ASSET__74295420__"